import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';
import { UiTranslationService } from '@core/services/ui-translation.service';
import { TrainAsset, TrainFlashcard } from '../../../deck-train.models';

@Component({
  selector: 'app-audio-record-train-front',
  templateUrl: './audio-record-train-front.html',
  styleUrl: './audio-record-train-front.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AudioRecordTrainFront {
  private readonly deckTranslations =
    inject(UiTranslationService).namespace('deck');

  readonly card = input.required<TrainFlashcard>();
  readonly imageAsset = input<TrainAsset | null>(null);
  readonly audioAsset = input<TrainAsset | null>(null);
  readonly isAudioPlaying = input(false);
  readonly playAudio = output<void>();

  readonly t = this.deckTranslations.t;

  get imageAlt(): string {
    return this.imageAsset()?.fileName || this.t()['train.frontImage'];
  }

  get hasAudio(): boolean {
    return Boolean(this.audioAsset()?.url);
  }
}
